import { TerminalDevice } from "../../components/organisms/softpos/TerminalDevice"
import { AdminTemplate } from "../../components"

export const TerminalDevicePage = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Cihazlar',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <TerminalDevice />
    </AdminTemplate>
  )
}
